export const getCookie = (name: string) => {
  if (!name) {return;}

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {return parts.pop()?.split(';').shift();}
};
